import React, { lazy } from 'react';
import { LazyComponent } from '../../../../components/LazyComponents';

// @ts-ignore
const SettingsPageLazy = lazy(() => import('./AccountSettingsPage'));

export function LazySettingsPage() {
  return <LazyComponent lazyComponent={<SettingsPageLazy />} />;
}
